// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_landing_stay_logged_in_notice = /** @type {(inputs: {}) => string} */ () => {
	return `We need to keep you logged in to keep your progress and personalise your learning experience.`
};

const id_landing_stay_logged_in_notice = /** @type {(inputs: {}) => string} */ () => {
	return `Kami perlu membuat Anda tetap masuk untuk memantau kemajuan Anda dan mempersonalisasi pengalaman belajar Anda.`
};

const ja_landing_stay_logged_in_notice = /** @type {(inputs: {}) => string} */ () => {
	return `あなたの進捗状況を維持し、学習体験をカスタマイズするには、ログイン状態を維持する必要があります。`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "id" | "ja" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const landing_stay_logged_in_notice = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.landing_stay_logged_in_notice(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("landing_stay_logged_in_notice", locale)
	if (locale === "en") return en_landing_stay_logged_in_notice(inputs)
	if (locale === "id") return id_landing_stay_logged_in_notice(inputs)
	return ja_landing_stay_logged_in_notice(inputs)
};
export { landing_stay_logged_in_notice as "landing.stay_logged_in_notice" }